import React from "react";
import { Logo } from "./Logo";
import { useI18n } from "../i18n/I18nContext";
import { Phone, Mail, MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "5493416612637";
const WHATSAPP_URL = `https://web.whatsapp.com/send?phone=${WHATSAPP_NUMBER}`;

const PHONES = [
  { label: "0800 - 345 - 1822", tel: "+08003451822" },
  { label: "+54 9 3416 612 637", tel: "+5493416612637" },
];

const EMAILS = [
  "administracion@instalros.com",
  "comercial@instalros.com",
  "soporte@instalros.com",
];

export const Footer = () => {
  const { t } = useI18n();
  return (
    <footer
      className="border-t border-white/[0.08] bg-[#050505] text-white/70"
      data-testid="site-footer"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 lg:grid-cols-12 gap-10">
        {/* Brand */}
        <div className="lg:col-span-4">
          <Logo size={32} />
          <p className="mt-6 text-sm leading-relaxed text-white/60 max-w-md">{t("footer.tag")}</p>
          <p className="mt-8 text-[11px] font-mono uppercase tracking-[0.25em] text-white/40">
            CA · CL · AR
          </p>
        </div>

        {/* Contact channels */}
        <div className="lg:col-span-5">
          <p className="tactical-label mb-4">{t("footer.contact")}</p>
          <ul className="space-y-2.5 text-sm">
            {PHONES.map((p) => (
              <li key={p.tel}>
                <a
                  href={`tel:${p.tel}`}
                  data-testid={`footer-phone-${p.tel}`}
                  className="inline-flex items-center gap-2.5 text-white/80 hover:text-[#19A7E0] transition-colors"
                >
                  <Phone className="w-3.5 h-3.5 text-[#19A7E0]" />
                  <span className="font-mono tracking-wide">{p.label}</span>
                </a>
              </li>
            ))}
            {EMAILS.map((e) => (
              <li key={e}>
                <a
                  href={`mailto:${e}`}
                  data-testid={`footer-email-${e.split("@")[0]}`}
                  className="inline-flex items-center gap-2.5 text-white/80 hover:text-[#19A7E0] transition-colors"
                >
                  <Mail className="w-3.5 h-3.5 text-[#19A7E0]" />
                  <span className="font-mono tracking-tight">{e}</span>
                </a>
              </li>
            ))}
          </ul>

          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-btn"
            className="mt-5 inline-flex items-center gap-2 px-4 py-2.5 bg-[#25D366] hover:bg-[#1EBE57] text-black text-xs font-mono uppercase tracking-[0.18em] rounded-sm transition-colors"
          >
            <MessageCircle className="w-4 h-4" />
            {t("footer.whatsapp")}
          </a>
        </div>

        {/* Legal */}
        <div className="lg:col-span-3">
          <p className="tactical-label mb-4">{t("footer.legal")}</p>
          <ul className="space-y-2 text-sm">
            <li><a href="#privacy" className="hover:text-white" data-testid="footer-privacy">{t("footer.privacy")}</a></li>
            <li><a href="#terms" className="hover:text-white" data-testid="footer-terms">{t("footer.terms")}</a></li>
            <li><a href="#compliance" className="hover:text-white" data-testid="footer-compliance">{t("footer.compliance")}</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/[0.08]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p
            className="text-[11px] font-mono uppercase tracking-[0.25em] text-white/40"
            data-testid="footer-copyright"
          >
            {t("footer.rights")}
          </p>
          <p className="text-[11px] font-mono uppercase tracking-[0.25em] text-white/40">
            v1.0.0 · Build 2026.02
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
